import * as Apis from "@api";

import useConfigMutation from "./useConfigMutation";

const useGlobalMutation = (() => {
  return useConfigMutation({ apis: Apis });
})();

export default useGlobalMutation;
